import type {
	acknowledgeBannerInput,
	createBannerInput,
	deleteBannerInput,
	getActiveBannersInput,
	updateBannerInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface Keys {
	useGetActiveBanners: getActiveBannersInput;
	useGetGenericBanners: undefined;
	useCreateBanner: createBannerInput;
	useUpdateBanner: updateBannerInput;
	useDeleteBanner: deleteBannerInput;
	useAcknowledgeBanner: acknowledgeBannerInput;
}

const BANNER_SERVICE_KEYS = createReactQueryKeys<Keys>("banners", [
	"useGetActiveBanners",
	"useGetGenericBanners",
	"useCreateBanner",
	"useUpdateBanner",
	"useDeleteBanner",
	"useAcknowledgeBanner",
]);

export { BANNER_SERVICE_KEYS };
